var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content !== undefined && _vm.showPage === true
    ? _c(
        "div",
        { staticClass: "startpage-container startpage px-0" },
        [
          _c(
            "div",
            { staticClass: "bg-white" },
            [
              _c("b-container", [
                _c(
                  "div",
                  {
                    staticClass: "top-container bg-white pb-4 p-4 text-brand",
                    style: {
                      backgroundImage: "url(" + _vm.nettedLinesNew + ")",
                    },
                  },
                  [
                    _c("div", { staticClass: "left-content pl-5 pt-4" }, [
                      _c("h1", [_vm._v(_vm._s(_vm.content.title))]),
                      _vm.content.buttonLink !== ""
                        ? _c(
                            "a",
                            { attrs: { href: _vm.content.buttonLink } },
                            [
                              _c(
                                "b-button",
                                { staticClass: "btn-brand-light my-4 fw-fat" },
                                [_vm._v(_vm._s(_vm.content.buttonText))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("p", {
                        staticClass: "mt-4",
                        domProps: {
                          innerHTML: _vm._s(_vm.content.description),
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "mobile-netted-line" }, [
                      _c("img", { attrs: { src: _vm.nettedLines2 } }),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "jobsearch-section bg-white d-flex align-items-center flex-column p-4 text-center",
            },
            [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.content.jobsearchText) },
              }),
            ]
          ),
          _c("div", { staticClass: "bottom-wave" }, [
            _c("img", { attrs: { src: _vm.imageWave } }),
          ]),
          _c("b-container", [
            _c(
              "div",
              { staticClass: "faq-container mx-4 pl-4 mb-4" },
              [
                _c("h1", [_vm._v(_vm._s(_vm.content.titleFAQ))]),
                _c("AccordionWithTitleDescription", {
                  attrs: { accordions: _vm.content.listFAQS },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }